import React from "react";
import styles from "./OnboardingStrategy.module.css";
import { cleanLines, stripBoldTitle, splitSentences } from "./utils";

const parseChecklist = (md = "") => {
  const lines = stripBoldTitle(cleanLines(md));
  const body = lines.join(" ").trim();
  const sentences = splitSentences(body);
  return { body, sentences };
};

const ActivationChecklist = ({ markdown = "" }) => {
  const { body, sentences } = parseChecklist(markdown);
  if (!body) return null;

  return (
    <div className={styles.container}>
      <h3 className={styles.heading}>Activation Checklist</h3>
      <div className={styles.card}>
        <div className={styles.sectionHeader}>
          <span>CHK</span>
          <span className={styles.sectionLabel}>Next Steps</span>
        </div>
        {sentences.length > 1 ? (
          sentences.map((sentence, idx) => (
            <div key={idx} className={styles.checkRow}>
              <div className={styles.checkCircle}>{idx + 1}</div>
              <span>{sentence}</span>
            </div>
          ))
        ) : (
          <p className={styles.paragraph}>{body}</p>
        )}
      </div>
    </div>
  );
};

export default ActivationChecklist;
